import { createContext, useContext } from "react";

import { FEATURE_FLAG } from "@/data/feature-flags";

interface FeatureFlagContext {
  featureFlags?: FEATURE_FLAG[];
  isFeatureEnabled: (name: FEATURE_FLAG) => boolean;
  isFeatureDisabled: (name: FEATURE_FLAG) => boolean;
}

export const FeatureFlagsContext = createContext<FeatureFlagContext>({} as FeatureFlagContext);

export const FeatureFlagsContextProvider = FeatureFlagsContext.Provider;

export const useFeatureFlags = () => {
  return useContext(FeatureFlagsContext);
};
